/**
 * Fake-db fixture for Compliance Suite Onboarding Blueprints (e2e mode).
 *
 * Served by FakeDbService.get() for GET …/suite/blueprints, because the nested
 * compliance URL is otherwise resolved (and 404'd) by the in-memory `compliance`
 * collection. Assignments are returned inline (TEZY2-4130) with resolved
 * targetName values so the list/detail render deterministically.
 *
 * Used by cypress/e2e/blueprint-assignment-display.cy.ts (TEZY2-4343 / TEZY2-4314).
 */

function mkAssignment(
  id: string,
  targetType: 'role' | 'venue' | 'client' | 'member',
  targetId: string,
  targetName: string,
  status: 'active' | 'revoked' = 'active'
) {
  return {
    id,
    blueprintId: 'bp-e2e-assign-1',
    blueprintVersion: 1,
    targetType,
    targetId,
    targetName,
    assignedBy: 'user-777',
    assignedAt: '2026-01-01T00:00:00Z',
    status
  };
}

export class BlueprintsFakeDb {
  public static blueprints = [
    // One active assignment per target type + one revoked (filtered out in UI).
    {
      id: 'bp-e2e-assign-1',
      accountId: 'acct-e2e',
      name: 'E2E Assignment Blueprint',
      description: 'Blueprint used to verify assignment chip rendering',
      requirements: [
        {
          categoryItemId: 'ci-1',
          category: 'individual_certifications',
          timingRequirement: 'before_commencement',
          mandatory: true
        }
      ],
      assignments: [
        mkAssignment('as-role', 'role', 'role-1', 'Bartender (Downtown Venue)'),
        mkAssignment('as-venue', 'venue', 'venue-1', 'Downtown Venue'),
        mkAssignment('as-client', 'client', 'client-1', 'Acme Corp'),
        // A person id (post-TEZY2-4345 member.UserID), NOT the account UUID.
        mkAssignment('as-member', 'member', 'user-jordan-777', 'Jordan Member'),
        mkAssignment('as-revoked', 'role', 'role-revoked', 'Revoked Role', 'revoked')
      ],
      status: 'active',
      version: 3,
      createdBy: 'user-777',
      createdAt: '2026-01-01T00:00:00Z',
      updatedAt: '2026-01-02T00:00:00Z'
    },
    // Role-only blueprint — exercises the "No members assigned" empty state.
    {
      id: 'bp-e2e-assign-2',
      accountId: 'acct-e2e',
      name: 'E2E Role-Only Blueprint',
      description: 'Blueprint with no member assignments',
      requirements: [
        {
          categoryItemId: 'ci-2',
          category: 'standards_guidelines',
          timingRequirement: 'during_shift',
          mandatory: false
        }
      ],
      assignments: [
        mkAssignment('as-role-only', 'role', 'role-9', 'Chef (Uptown Venue)')
      ],
      status: 'active',
      version: 1,
      createdBy: 'user-777',
      createdAt: '2026-01-01T00:00:00Z',
      updatedAt: '2026-01-02T00:00:00Z'
    }
  ];
}
